export default {
	"AddressItem.edit": "编辑"
}